<template>
  <div class="app page-sidebar-fixed page-header-fixed">
    <nav-bar class="navbar-fixed"></nav-bar>
    <div class="wrapper">
      <Sidebar :navItems="nav" @sidebar-resize="updateSidebarWidth" ref="sidebarRef" />
      <div id="content" class="content" :style="{ paddingLeft: sidebarWidth + 'px' }">
        <router-view></router-view>
      </div>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import Navbar from '../components/Navbar'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    'nav-bar': Navbar
  },
  data() {
    return {
      nav: nav.items,
      sidebarWidth: 120 
    }
  },
  methods: {
    updateSidebarWidth(width) {
      this.sidebarWidth = width;
    }
  },
  mounted() {
    this.updateSidebarWidth(this.$refs.sidebarRef.getSidebarWidth());
    window.addEventListener('resize', () => {
      this.updateSidebarWidth(this.$refs.sidebarRef.getSidebarWidth());
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.updateSidebarWidth(this.$refs.sidebarRef.getSidebarWidth());
    });
  }
}
</script>

<style>
.app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.navbar-fixed {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.wrapper {
  display: flex;
  flex: 1;
  padding-top: 60px; 
}

#content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  height: calc(100vh - 60px);
}
.form-control {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/admin/containers/Full.vue